export default class MockRecallAPI {
  constructor(api, version) {
    this.api = api;
    this.version = version;
  }
}